import { render, staticRenderFns } from "./ProcessNodeEditor.vue?vue&type=template&id=45df95ca&scoped=true&"
import script from "./ProcessNodeEditor.vue?vue&type=script&lang=js&"
export * from "./ProcessNodeEditor.vue?vue&type=script&lang=js&"
import style0 from "./ProcessNodeEditor.vue?vue&type=style&index=0&id=45df95ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45df95ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabItem } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
import { VTabsItems } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VCheckbox,
  VSelect,
  VTab,
  VTabItem,
  VTabs,
  VTabsItems,
  VTextField,
})
